import { styled } from '../styled-components'

export const Input = styled.input`
  font: ${props => props.theme.textFont};
  background: ${props => props.theme.inputBackgroundColor};
  color: ${props => props.theme.textColor};
  height: 35px;
  font-size: 17px;
  line-height: 35px;
  padding: 0 10px;
  border: none;
  border-radius: 2px;
  &::placeholder {
    color: ${props => props.theme.lightTextColor};
  }
`
